import {DialogType, ZdsActivityType} from "@/config";
import {PageContext} from "@zto/zpage-runtime";
import {ZdsOrderDeliveryType} from "@/pages/orderlist/config";

const formItemStyleAttrs = Object.freeze({ style: 'width: 400px;' })

/**
 * 新增编辑对话框
 * @returns
 */
export function addEditDialog(dialogType: DialogType = DialogType.ADD) {
  const isAdd = dialogType === DialogType.ADD
  const isEdit = dialogType === DialogType.EDIT
  const isView = dialogType === DialogType.VIEW

  return {
    width: 800,
    labelWidth: 160,
    title:'新建分账',
    // debug: true,

    formAttrs: {
      disabled: isView
    },

    formItemsAttrs: {
    },

    onShow: async ({ data }: PageContext) => {
      let payload = { ...data }

      payload.bindCatSpuList = payload.spuInfoVOList

      return { payload }
    },
    //
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      // const payload = processJumpDataForSubmit({ ...model.value })
      //
      // delete payload._isApi
      // delete payload._oldData

      debugger
      const payload = {
        ...data
      }
      // payload.bindCatSpuList = payload.bindCatSpuList.map((v: any) => {
      //   return {
      //     spuCode: v,
      //     sort:1,
      //   }
      // })
      return payload
    },
    // onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
    //
    //   debugger
    //
    // },
    formItems: [

      { label: '无人车SN', type: 'input', prop: 'vehicleSn',  required: true },
      { label: '是否直投',
        type: 'checkbox',
        span: 23,
        checkType: 'radio',
        prop: 'isDirectInvestment',
        required: true,
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ],
      },
      {
        label: '配送单价（元）',
        type: 'input-number',
        prop: 'deliveryUnitPrice',
        min: 0,
        default: 0,
        precision: 2,
        span: 11
      },
      {
        labelWidth: 0,
        type: 'html',
        html: '<span class="text-red">最低0.1，最高999，支持2位小数</span>',
        span: 13
      },

      {
        label: '收款方',
        type: 'payment-collection',
        autoHeight: true,
        prop: 'receivers',
        labelProp: 'receivers',
        span: 24,
        dynamicAttrs: ({ data }: PageContext) => {
          const hidden = data.applicableProductType ===  ZdsActivityType.All
          return { hidden, required: !hidden }
        }
      },

      {
        label: '分账开始时间',
        type: 'date-picker',
        prop: 'effectiveTime',
        pickerType: 'datetime',
        format: 'YYYY-MM-DD HH:mm',
        afterToday: true,
        span: 23,
        disabled: isEdit,
        beforeDate: 'T+30d',
        afterDate: 'T+0d',
        itemAttrs: formItemStyleAttrs,
        dynamicAttrs: ({ data }: PageContext) => {

          const visible = true
          return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
        }
      },

      {
        label: '分账结束时间',
        type: 'date-picker',
        prop: 'expireTime',
        pickerType: 'datetime',
        format: 'YYYY-MM-DD HH:mm',
        afterToday: true,
        disabled: isEdit,
        beforeDate: 'T+30d',
        afterDate: 'T+0d',
        itemAttrs: formItemStyleAttrs,
        dynamicAttrs: ({ data }: PageContext) => {
          const visible = true
          return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
        }
      },

    ],
  }
}





